<template>
  <div>
    <div class="dialog-content">
      <div class="row-name">
        是否下架
        <template v-for="(item, index) in dialogInfo.titleArr">
          <label >{{item}}</label>
          <span v-if="index < dialogInfo.titleArr.length-1">、</span>
        </template>
        商品？
      </div>
      <div class="row-content">下架商品后，以下礼包也会同步下架，请确认是否下架商品。</div>
      <div class="gift-msg">
        <div>受到影响的礼包：</div>
        <ul class="gift-msg-list">
          <li v-for="item in list">{{ item.name }}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
// const decLiteral: number = 6;
// console.log('decLiteral', decLiteral)
import { defineComponent, ref, reactive } from '@vue/composition-api'
export default defineComponent({
  name: 'ModifyState',
  components: {},
  props: {
    dialogInfo: {
      type: Object,
      required: true,
      default: () => {}
      // default: () => { totalNum: 0, price: 0,list: [] }
    },
    list: {
      type: Array,
      required: true,
      default: () => []
      // default: () => { totalNum: 0, price: 0,list: [] }
    }
  },
  data () {
    return {
      previewImg: '',
      visible: false
    }
  },
  methods: {
    centerModifyState () {
      this.dialog.visible = false
    },
    submitModifyState () {
      this.dialog.visible = false
    }
  }
})
</script>
<style lang="scss">
//@import '../style/modifyState.scss';
</style>
